import { useState, useMemo, useCallback } from "react";

const useTableSort = (data) => {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const sortedData = useMemo(() => {
    if (!sortConfig.key) return data;

    const sorted = [...data].sort((a, b) => {
      const aVal = a[sortConfig.key];
      const bVal = b[sortConfig.key];

      if (typeof aVal === "number" && typeof bVal === "number") {
        return sortConfig.direction === "asc" ? aVal - bVal : bVal - aVal;
      }

      return sortConfig.direction === "asc"
        ? String(aVal).localeCompare(String(bVal))
        : String(bVal).localeCompare(String(aVal));
    });

    return sorted;
  }, [data, sortConfig]);

  const requestSort = useCallback((key, direction = null) => {
    if (direction === "asc" || direction === "desc") {
      setSortConfig({
        key,
        direction
      });
    }
    //no direction first asc and then desc fashion
    else
      setSortConfig((prev) => {
        if (!key) {
          return { key: null, direction: "asc" };
        }
        if (prev.key === key) {
          return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
        }
        return { key, direction: "asc" };
      });
  }, []);

  return { sortedData, requestSort, sortConfig };
};

export default useTableSort;
